__turbopack_context__.v({
  "distributionCarousel": "Distribution-module-scss-module__maV6tG__distributionCarousel",
  "distributionHeader": "Distribution-module-scss-module__maV6tG__distributionHeader",
  "distributionPhaseLink": "Distribution-module-scss-module__maV6tG__distributionPhaseLink",
  "distributionPhaseLinkActive": "Distribution-module-scss-module__maV6tG__distributionPhaseLinkActive",
  "distributionPlanLink": "Distribution-module-scss-module__maV6tG__distributionPlanLink",
  "distributionsCaret": "Distribution-module-scss-module__maV6tG__distributionsCaret",
  "distributionsCaretDisabled": "Distribution-module-scss-module__maV6tG__distributionsCaretDisabled",
  "distributionsCaretWrapper": "Distribution-module-scss-module__maV6tG__distributionsCaretWrapper",
  "distributionsScrollContainer": "Distribution-module-scss-module__maV6tG__distributionsScrollContainer",
  "distributionsTable": "Distribution-module-scss-module__maV6tG__distributionsTable",
  "distributionsTableWallet": "Distribution-module-scss-module__maV6tG__distributionsTableWallet",
  "totalResults": "Distribution-module-scss-module__maV6tG__totalResults",
});
